import { ColumnState } from 'ag-grid-community';

export class SetColumnSetting {
  static readonly type = '[AgGridColumnSettings] Set column settings';
  constructor(
    public payload: {
      userId: string;
      gridId: string;
      columnStates: ColumnState[];
    },
  ) {}
}

export class SetPageSizeSetting {
  static readonly type = '[AgGridColumnSettings] Set page size setting';
  constructor(
    public payload: {
      userId: string;
      gridId: string;
      pageSize: number;
    },
  ) {}
}
